import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lock, EnvelopeSimple } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C] px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1
            data-testid="login-title"
            className="text-4xl font-black tracking-tighter text-white"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            CMS<span className="text-[#E53935]">Portal</span>
          </h1>
          <p className="text-[11px] text-[#A1A1AA] tracking-[0.2em] uppercase mt-2">Admin Panel</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <EnvelopeSimple size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A1A1AA]" />
            <Input
              data-testid="login-email-input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="pl-9 bg-[#141417] border-[#2A2A2E] text-white placeholder:text-[#555] rounded-sm h-11 focus:border-[#E53935] focus:ring-[#E53935]"
              required
            />
          </div>
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A1A1AA]" />
            <Input
              data-testid="login-password-input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pl-9 bg-[#141417] border-[#2A2A2E] text-white placeholder:text-[#555] rounded-sm h-11 focus:border-[#E53935] focus:ring-[#E53935]"
              required
            />
          </div>

          {error && (
            <div data-testid="login-error" className="text-[#E53935] text-sm bg-[#E53935]/5 border border-[#E53935]/20 px-3 py-2 rounded-sm">
              {error}
            </div>
          )}

          <Button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full h-11 bg-[#E53935] hover:bg-[#C62828] text-white rounded-sm font-semibold tracking-wide transition-colors duration-200"
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
